import helpers from '../helpers';

const positionBanner = () => {
	const map = document.querySelector('.map__media');
	const banner = document.querySelector('.map__banner');
	if (helpers.isMobile()) {
		return;
	}
	let position = map.offsetLeft - banner.offsetWidth;
	if (position < 0) {
		position = 10;
	}
	banner.style.left = `${position}px`;
};

export {positionBanner};
